import styled, { css } from 'styled-components';
import { themeHelpers } from '@gotamedia/fluffy/theme';
import { Link as UnstyledLink } from '@remix-run/react';
const Wrapper = styled.header.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-1snoyy5-0"
})(["width:100%;display:flex;min-height:44px;border-top:1px solid ", ";border-bottom:1px solid ", ";"], ({
  theme
}) => theme.colors.grey[4], ({
  theme
}) => theme.colors.grey[4]);
const InnerWrapper = styled.div.withConfig({
  displayName: "style__InnerWrapper",
  componentId: "sc-1snoyy5-1"
})(["max-width:1320px;width:90%;margin:0 auto;display:flex;position:relative;align-items:center;", ""], themeHelpers.isSmallDevice(css(["width:95%;"])));
const Anchor = styled.a.withConfig({
  displayName: "style__Anchor",
  componentId: "sc-1snoyy5-2"
})(["margin:auto 0;margin-right:15px;color:", ";font-family:'Sanomat Sans';font-style:normal;font-weight:700;font-size:16px;line-height:24px;", " &:last-of-type{margin-right:0;}"], ({
  theme
}) => theme.colors.black, themeHelpers.isSmallDevice(css(["margin-right:0;"])));
const Link = styled(UnstyledLink).withConfig({
  displayName: "style__Link",
  componentId: "sc-1snoyy5-3"
})(["margin-right:15px;font-family:'Sanomat Sans';font-style:normal;font-weight:700;font-size:16px;line-height:24px;color:", ";padding:0 4px;height:100%;display:flex;align-items:center;", " ", " &:last-of-type{margin-right:0;}"], ({
  theme
}) => theme.colors.black, themeHelpers.isSmallDevice(css(["margin-right:10px;"])), ({
  $active
}) => $active && css(["box-shadow:inset 0 -3px 0 0 ", ";"], ({
  theme
}) => theme.colors.brand));
export { Link, Anchor, InnerWrapper, Wrapper };